import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-image-guidelines',
  templateUrl: './image-guidelines.component.html',
  styleUrls: ['./image-guidelines.component.scss']
})
export class ImageGuidelinesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
